<template>
  <v-card class="pa-2 mt-3" outlined flat>
    <v-form>
      <v-container>
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field v-model="items.provider" label="Provider" :outlined="outlined"></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="items.individualName" label="Individual Served Name"
              :outlined="outlined"></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="items.year" label="year" :outlined="outlined"></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="items.caseNo" label="Case No" :outlined="outlined"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="white--text text-uppercase text-center text-caption"
            style="background-color: #2b3990">Reporting Period
          </v-col>
          <v-col>
            <v-row>
              <v-col cols="12" sm="6">
                <v-checkbox v-model="items.chkJFM" label="January, February, March (Due by May 5th)"
                  value="John"></v-checkbox>
                <v-checkbox v-model="items.chkAMJ" label="April, May, June (Due by August 5th)"
                  value="Jacob"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="6">
                <v-checkbox v-model="items.chkJAS" label="July, August, September (Due by Nov. 5th)"
                  value="Jacob"></v-checkbox>
                <v-checkbox v-model="items.chkOND" label="October, November, December (Due by Feb. 5th)"
                  value="Jacob"></v-checkbox>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="white--text text-uppercase text-center text-caption"
            style="background-color: #2b3990">Services
          </v-col>
          <v-col>
            <p class="font-weight-bold">Check Service Type Provided:</p>
            <v-row>
              <v-col cols="12" sm="3">
                <v-text-field v-model="items.dayHabilitation" label="Day Habilitation (T2021)"
                  :outlined="outlined"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field v-model="items.preVocational" label="Pre-Vocational (T2047)"
                  :outlined="outlined"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field v-model="items.supportedEmployment" label="Supported Employment (T2019)"
                  :outlined="outlined"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field v-model="items.careerPlanning" label="Career Planning (T2019)"
                  :outlined="outlined"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="items.locationService" label="Location of Service"
                  :outlined="outlined"></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row v-for="(item, i) in  items.months" :key="i">
              <v-col>
                <v-sheet elevation="1" class="month--sheet pa-5">
                  <v-btn v-if="items.months.length > 1" color="red" dark right x-small max-height="25" max-width="25"
                    class="fab--btn delete" fab @click=removeMonth>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="item.monthEarnings" label="Monthly Earnings"
                        :outlined="outlined"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="item.monthAbsent" label="Days Absent"
                        :outlined="outlined"></v-text-field>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>


            </v-row>
            <div v-if="items.months.length < 3" class="d-flex mt-3 mb-3 d-flex justify-end ">
              <v-btn color="primary" dark right max-height="25" max-width="25" class="" @click="addMonth">
                add
              </v-btn>
            </div>

            <v-row>
              <v-col cols="12" sm="12">
                <v-text-field v-model="items.hourlyWage" label="Hourly Wage" :outlined="outlined"></v-text-field>
              </v-col>
            </v-row>
          </v-col>

        </v-row>

        <v-row>
          <v-col cols="12" class="white--text text-uppercase text-center text-caption"
            style="background-color: #2b3990">Describe specific progress toward PCP Support Plans in this reporting
            period.
          </v-col>
          <v-col>
            <v-row v-for="(item, i) in items.scopeObjectives" :key="i">
              <v-col>
                <v-sheet elevation="1" class="pa-5">
                  <v-btn v-if="items.scopeObjectives.length > 1" color="red" dark right x-small max-height="25"
                    max-width="25" class="fab--btn delete" fab @click=removeScopeObjective>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="item.scope" label="Scoped" :outlined="outlined"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="item.objective" label="Objective" :outlined="outlined"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <v-text-field v-model="item.summary"
                        label="Describe progress toward scope/objectives including summary of data collected: (in box below)"
                        :outlined="outlined"></v-text-field>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
            </v-row>
            <div v-if="items.scopeObjectives.length < 4" class="d-flex mt-3 mb-3 d-flex justify-end ">
              <v-btn color="primary" dark right max-height="25" max-width="25" class="" @click="addScopeObjective">
                add
              </v-btn>
            </div>
          </v-col>

          <v-col cols="12" sm="12">
            <v-text-field v-model="items.supports"
              label="Describe protective oversight and supervision supports: (in box below)"
              :outlined="outlined"></v-text-field>
          </v-col>

          <v-col cols="12" sm="12">
            <v-text-field v-model="items.comment"
              label="Additional Comment (to include any concerns, accomplishments, social interaction, etc.): (in box below)"
              :outlined="outlined"></v-text-field>
          </v-col>

          <v-col cols="12" sm="12">
            <v-text-field v-model="items.familyContactDesc"
              label="Describe your contact with home and/or family: (in box below)" :outlined="outlined"></v-text-field>
          </v-col>

          <v-col>
            <p class="font-weight-bold">Current Medication: (as of this report date):</p>
            <v-row v-for="(item, i) in items.currentMedication" :key="i">
              <v-col>
                <v-sheet elevation="1" class="pa-5">
                  <v-btn v-if="items.currentMedication.length > 1" color="red" dark right x-small max-height="25"
                    max-width="25" class="fab--btn delete" fab @click=removeCurrentMedication>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-row>
                    <v-col cols="12" sm="4">
                      <v-text-field v-model="item.medication" label="Medication" :outlined="outlined"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field v-model="item.dosage" label="Dosage" :outlined="outlined"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field v-model="item.physician" label="Physician" :outlined="outlined"></v-text-field>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
            </v-row>
            <div v-if="items.currentMedication.length < 3" class="d-flex mt-3 mb-3 d-flex justify-end ">
              <v-btn color="primary" dark right max-height="25" max-width="25" class="" @click="addCurrentMedication">
                add
              </v-btn>
            </div>
          </v-col>

          <v-col cols="12" sm="12">
            <v-text-field v-model="items.medicationSideEffect" label="Medication Side Effects Observed: (in box below)"
              :outlined="outlined"></v-text-field>
          </v-col>

        </v-row>

        <v-row>
          <v-col cols=12>
            <div class="d-flex align-center">
              <span class="font-weight-bold  mr-2">Current Medication: (as of this report date):</span>
              <div class="d-flex">
                <v-checkbox label="No Change" value="No"></v-checkbox>
                <div class="ma-1"></div>
                <v-checkbox label="(if yes, complete the boxes in the table below)" value="Yes"></v-checkbox>
              </div>
            </div>
          </v-col>

          <v-col cols=12>
            <v-row v-for="(item, i) in items.medicationChange" :key="i">
              <v-col>
                <v-sheet elevation="1" class="pa-5">
                  <v-btn v-if="items.medicationChange.length > 1" color="red" dark right x-small max-height="25"
                    max-width="25" class="fab--btn delete" fab @click=removeMedicationChange>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-row>
                    <v-col cols="12" sm="3">
                      <v-text-field v-model="item.changeMedication" label="Medication"
                        :outlined="outlined"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field v-model="item.changeDosage" label="Dosage" :outlined="outlined"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field v-model="item.reasonChange" label="Reason for change"
                        :outlined="outlined"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field v-model="item.physicianChange" label="Physician"
                        :outlined="outlined"></v-text-field>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
            </v-row>
            <div v-if="items.medicationChange.length < 2" class="d-flex mt-3 mb-3 d-flex justify-end ">
              <v-btn color="primary" dark right max-height="25" max-width="25" class="" @click="addMedicationChange">
                add
              </v-btn>
            </div>
          </v-col>
          <v-col cols="12" sm="12">
            <v-text-field v-model="items.requiredSummary" label="Required Right of the Month Training: Summarize rights training technique, assistance person needs and persons response
            (in box below)" :outlined="outlined"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <p class="font-weight-bold">Report Completed By:</p>
            <v-row>
              <v-col cols="12" sm="4">
                <v-text-field v-model="items.completedBy" label="Print" :outlined="outlined"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="items.completedBySignature" label="Signature"
                  :outlined="outlined"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="items.completedByDate" label="Date" :outlined="outlined"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <p class="font-weight-bold">QIDP Review By:</p>
            <v-row>
              <v-col cols="12" sm="4">
                <v-text-field v-model="items.reviewedBy" label="Print" :outlined="outlined"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="items.reviewedBySignature" label="Signature" :outlined="outlined"></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="items.reviewedByDate" label="Date" :outlined="outlined"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>
<script>

/*eslint-disable */
export default {
  props: {
    items: Object
  },
  data() {
    return {
      outlined: true,
      // items: {
      //   months: [{}],
      //   scopeObjectives: [{}],
      //   currentMedication: [{}],
      //   medicationChange: [{}]
      // }
    };
  },
  methods: {

    getItems(){
      return this.items
    },
    
    getData() {
      return this.flattenArrays(this.items)
    },

    addMonth() {
      this.items.months.push({})
    },

    removeMonth(i) {
      this.items.months.splice(i, 1)
    },

    addScopeObjective() {
      this.items.scopeObjectives.push({})
    },

    removeScopeObjective(i) {
      this.items.scopeObjectives.splice(i, 1)
    },

    addCurrentMedication() {
      this.items.currentMedication.push({})
    },

    removeCurrentMedication(i) {
      this.items.currentMedication.splice(i, 1)
    },

    addMedicationChange() {
      this.items.medicationChange.push({})
    },

    removeMedicationChange(i) {
      this.items.medicationChange.splice(i, 1)
    },


    flattenArrays(data) {
      const flattened = {};

      Object.entries(data).forEach(([key, value]) => {
        if (!Array.isArray(value)) {
          flattened[key] = value;
        } else {
          value.forEach((item, index) => {
            Object.entries(item).forEach(([innerKey, innerValue]) => {
              flattened[`${innerKey}${index + 1}`] = innerValue;
            });
          });
        }
      });

      return flattened;
    }
  },
};
</script>

<style scoped>
h1 {
  font-size: 1.5rem;
  font-weight: 400;
}

.fab--btn {
  display: "absolute";
  bottom: 10px;
}

.fab--btn.delete {
  right: calc(-100% + 20px);
}
</style>
